import { listPoze } from "./listPoze";
import DivPoze from "./DivPoze";

export default function Photos() {return(
    <>
        <div className="grid grid-cols-5 gap-6 px-5">
            {listPoze.map((obj) => <DivPoze obj={obj} />)}
        </div>
    </>)
}